import { Link } from "react-router-dom";

import { ImageWithFallback } from "simplydo/react/components/ImageWithFallback";
import { styled } from "simplydo/react/styled";
import {
  Icon,
  Popup,
  type SemanticCOLORS,
  type SemanticICONS,
} from "simplydo/react/ui";

import util from "utils/utils";

import { StyledSearchItem } from "./SearchItem";
import type { OmniSearchUser } from "./types";

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    line-height: 1rem;
  }
`;

type UserSearchItemProps = {
  user: OmniSearchUser;
  active?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const UserSearchItem = ({
  user,
  active,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: UserSearchItemProps) => {
  const { profile } = user;
  const fullName = profile?.fullName ?? "";
  const jobTitle = profile?.jobTitle ?? "";
  const department = profile?.department ?? "";
  return (
    <StyledSearchItem
      onClick={onClick}
      $active={active}
      as={Link}
      to={`/users/${user._id}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ImageWithFallback
        avatar
        src={util.avatarUrl(user)}
        fallbackSrc={util.avatarUrl()}
        style={{ height: "1rem", width: "1rem" }}
      />
      <StyledInfoContainer>
        <p style={{ marginBottom: 0 }}>
          {fullName}
          {user.iconRoles?.[0] ? (
            <Popup
              content={`This user has the following role: ${user.iconRoles[0]?.name}`}
              trigger={
                <Icon
                  name={user.iconRoles[0]?.icon?.name as SemanticICONS}
                  color={user.iconRoles[0]?.icon?.colour as SemanticCOLORS}
                  style={{ marginLeft: 5 }}
                />
              }
            />
          ) : null}
        </p>
        {(jobTitle || department) && (
          <p style={{ marginBottom: 0, color: "#4e585c", fontSize: 12 }}>
            {jobTitle}
            {jobTitle && department && " - "}
            {department}
          </p>
        )}
      </StyledInfoContainer>
    </StyledSearchItem>
  );
};

export default UserSearchItem;
